export default "__VITE_ASSET__ce8b00e6__"